<video class="videots-player" controls preload="auto" #videoPlayer ></video>

<div *ngIf="noGetVideo" class="noChannelTransmition">
  <p>{{ 'DASHCAM.NO_CHANNEL_TRANSMITION' | translation }}</p>
</div>
